export default __webpack_public_path__ + "static/media/collapse-icon.128c55ff.svg";